module.exports = __webpack_public_path__ + "static/media/slider-3.f99368bf.jpg";